import DeviceManager from './utils/device-manager';
import QualificationsCarousel from './components/qualifications-carousel';
import SinglePostListCarousel from './components/single-post-list-carousel';
import HomeListeProduitsCarousel from './components/home-liste-produits-carousel';
import CircularProgress from './components/circular-progress';
import ReadingTime from './components/reading-time';
import Footer from './components/footer';
import MemberAreaModal from './components/member-area-modal';
import MemberAreaPopoverActions from './components/member-area-popover-actions';
import Modal from './components/modal';
import BlogFilterByCate from './components/blog-filter-by-cate';
import Appear from './components/appear';
import initAccordeons from './components/accordeon';
import Carousel from './components/carousel';
import OfferStickyNav from './components/offer-sticky-nav';
import TableComparison from './components/table-comparison';
import SonarEmitter from './components/sonar-emitter';
import FullHeight from './components/full-height';
import { initTimelines } from './components/timeline';
import { initReadMore } from './components/read-more';
import TabsPushServices from './components/tabs-push-services';
import { initHeader } from './components/header';
import PushServicesHeightHeaderAdjust from './components/push-services-height-header';
import AnimStrateChiffres from './components/anim-strate-chiffres';
import FormValidation from './components/form-validation';
import { initRegisterForm } from './components/register-form';
import { initChangePasswordForm } from './components/change-password-form';
import { initBillingContactForm } from './components/billing-contact-form';
import { initAedForm } from './components/aed-form';
import { initTabs } from './components/tab';
import { initCollectionFields } from './components/collection-field';
import { initAddToCart } from './components/add-to-cart';
import { initCart } from './components/cart';
import ExpandCollapse from './components/expand-collapse';
import { initNumberModifier } from './components/number-modifier';
import inputFilesCustom from './components/input-files-custom';
import SmoothScrollAnchor from './components/smooth-scroll';
import { initFaqAnchor } from './components/faq-anchor';
import FaqSearchAutocomplete from './components/faq-search-autocomplete';
import RelevantContent from './components/relevant-content';
import { initPhoneOtpModule } from './components/phone-otp-module';
import { initConfigurateOrderStep2 } from './components/configurate-order-step-2';
import { initConfigurateOrderStep3 } from './components/configurate-order-step-3';
import { initConfigurateOrderStep5 } from './components/configurate-order-step-5';
import { initCsrForm } from './components/csr-form';
import { initOptionalFiles } from './components/optional-files';
import Cookies from './components/cookies';
import { initOrderFilters } from './components/order-filters';
import { initMyOrdersCancelButton } from './components/my_orders_cancel';
import FlashMessages from './components/flash-message';
import disableCopyPast from './components/disable-copy-paste';
import initToggler from './components/toggler';
import initAnalyticsEvents from './components/analytics';
import openWhitePaperWithHash from './components/white-paper';
import initSelectTextSuggestions from './components/select-text-suggestions';
import { initDownloadLinkIfLoggedIn } from './components/download-link-if-logged-in';
import initBtnLoading from './components/btn-loading';
import initContactSearch from './components/contact-search';
import initCopyInClipboardButtons from './components/clipboard-copy';
import { initMyOrdersAjaxLoad } from './components/my-orders-ajax-load';
import PaymentForm from './components/payment-form';
import initEditUserForm from './components/edit-user-form';
import initCustomPasswordFields from './components/custom-password-field';
import { initTippy } from './components/tippy';
import initContactForm from './components/contact-form';
import { initPredefinedCart } from './components/predefined-cart';
import { initDropdown } from './components/dropdown';
import { initPartnerCredentialsAction } from './components/my-partners';
import { initYoutubeIframe } from './components/youtube-iframe';
import { initPvid } from './components/pvid';
import { initRevocationForms } from './components/revocation-form';
import { initAcmeAddOrganizationForm } from './components/acme-add-organization-form';
import { initFormSubmitConfirmationModals } from './components/form-submit-confirmation-modal';
import { initAcmeRevocationForm } from './components/acme-revocation-form';
import { initAcmeEditExternalAccountForm } from './components/acme-edit-external-account-form';
import { initAcmeEditAccountForm } from './components/acme-edit-account-form';
import { initAcmeAddDomainForm } from './components/acme-add-domain-form';
import { initAcmeEditDomainForm } from './components/acme-edit-domain-form';
import { initAcmeViewAccount } from './components/acme-view-account';
import { initAcmeViewRequest } from './components/acme-view-request';
import { initTagifyField } from './components/tagify-field';
import { initConvertToSSLAcmeToken } from './components/convert-to-ssl-acme-token';

new Cookies();
initAnalyticsEvents();
initHeader();
Appear.init();
initAccordeons();
Carousel.init();
FullHeight.init();
initTimelines();
initReadMore();
CircularProgress.init();
ReadingTime.init();
HomeListeProduitsCarousel.init();
QualificationsCarousel.init();
SinglePostListCarousel.init();
BlogFilterByCate.init();
Footer.init();
AnimStrateChiffres.init();
Modal.init();
MemberAreaModal.init();
MemberAreaPopoverActions.init();
OfferStickyNav.init();
TableComparison.init();
SonarEmitter.init();
TabsPushServices.init();
PushServicesHeightHeaderAdjust.init();
initTagifyField();
initRegisterForm();
initChangePasswordForm();
initBillingContactForm();
initAedForm();
FormValidation.init();
initTabs();
initCollectionFields();
initAddToCart();
initCart();
initPredefinedCart();
ExpandCollapse.init();
initNumberModifier();
inputFilesCustom.init();
PaymentForm.init();
openWhitePaperWithHash();
SmoothScrollAnchor.init();
initFaqAnchor();
FaqSearchAutocomplete.init();
RelevantContent.init();
initPhoneOtpModule();
initDownloadLinkIfLoggedIn();
initConfigurateOrderStep2();
initConfigurateOrderStep3();
initConfigurateOrderStep5();
initCsrForm();
initOptionalFiles();
initOrderFilters();
initMyOrdersCancelButton();
disableCopyPast();
initToggler();
initSelectTextSuggestions();
initContactSearch();
initBtnLoading();
initCopyInClipboardButtons();
initMyOrdersAjaxLoad();
initEditUserForm();
initCustomPasswordFields();
initTippy();
initContactForm();
initDropdown();
initPartnerCredentialsAction();
initYoutubeIframe();
initPvid();
initRevocationForms();
initAcmeAddOrganizationForm();
initFormSubmitConfirmationModals();
initAcmeRevocationForm();
initAcmeEditExternalAccountForm();
initAcmeEditAccountForm();
initAcmeAddDomainForm();
initAcmeEditDomainForm();
initAcmeViewAccount();
initAcmeViewRequest();
initConvertToSSLAcmeToken();
FlashMessages.init();

// Always call after all other files
DeviceManager.init();
